import React from 'react';

export default function formatTimeToSeconds(time: string): number {
  const [hours, minutes, seconds] = time.split(':').map(Number);

  const totalSeconds = hours * 3600 + minutes * 60 + seconds;

  return totalSeconds;
}
